<template>
    <div class="">
        <h3 class="text-center">INFORMAÇÕES DO PROCESSO - {{capa.dadosGeraisCapa.PROCESSO}} </h3>
        <div class="table border p-2">
            <div class="row">
                <div class="col-12 col-md-4 mb-2">
                    <p v-if="(tipo == 'CAI' || tipo == 'CAE')"><strong>Master: </strong>  <span>{{ capa.dadosGeraisCapa.MASTER || "----" }}</span></p>
                    <p><strong>House: </strong>   <span>{{ capa.dadosGeraisCapa.HOUSE || "----"   }}</span></p>
                    <p><strong>Cliente: </strong> <span>{{ capa.dadosGeraisCapa.CLIENTE || "----" }}</span></p>
                    <p><strong>Referência: </strong>  <span>{{ capa.dadosGeraisCapa.REF_CLIENT || "----" }}</span></p>
                    <p><strong>Exportador: </strong>   <span>{{ capa.dadosGeraisCapa.SHIPPER || "----"   }}</span></p>
                    <p><strong>Importador: </strong>  <span>{{ capa.dadosGeraisCapa.CNEE || "----" }}</span></p>
                    <p v-if="(tipo == 'CMI')"><strong>CE: </strong>  <span>{{ capa.dadosGeraisCapa.CE || "----" }}</span></p>
                    <p><strong>ETD: </strong>   <span>{{ capa.dadosGeraisCapa.ETD || "----"   }}</span></p>
                    <p><strong>ETA: </strong> <span>{{ capa.dadosGeraisCapa.ETA || "----"}}</span></p>
                    <p><strong>Carrier: </strong>   <span>{{ capa.dadosGeraisCapa.CARRIER || "----"   }}</span></p>
                    <p><strong>Mercadoria: </strong>  <span>{{ capa.dadosGeraisCapa.MERCADORIA  || "----" }}</span></p>
                    <p><strong>Volumes: </strong>   <span>{{ capa.dadosGeraisCapa.VOLUMES || "----"   }}</span></p>
                    <p><strong>Gross: </strong> <span>{{ capa.dadosGeraisCapa.PESO_BRUTO || "----" }}</span></p>
                </div>
                <div class="col-12 col-md-4 mb-2">
                    <p><strong>Origem: </strong> <span>{{ capa.dadosGeraisCapa.ORIGIN || "----"}}</span></p>
                    <p><strong>Destino: </strong> <span>{{ capa.dadosGeraisCapa.DESTINATION || "----"}}</span></p>
                    <p><strong>Cotação: </strong> <span>{{ capa.dadosGeraisCapa.COTACAO || "----"}}</span></p>
                    <p><strong>M3: </strong> <span>{{ capa.dadosGeraisCapa.M3 || "----"}}</span></p>
                    <p><strong>Peso a Cobrar: </strong> <span>{{ capa.dadosGeraisCapa.PESO_COBRAR || "----"}}</span></p>
                    <p><strong>CNPJ: </strong> <span>{{ capa.dadosGeraisCapa.CNPJ || "----"}}</span></p>
                    <p><strong>Incoterm: </strong> <span>{{ capa.dadosGeraisCapa.INCOTERM || "----"}}</span></p>
                    <p v-if="(tipo == 'CMI' || tipo == 'CME')"><strong>Navio: </strong> <span>{{ capa.dadosGeraisCapa.NAVIO || "----" }}</span></p>
                    <p><strong>Viagem: </strong> <span>{{ capa.dadosGeraisCapa.VIAGEM || "----" }}</span></p>
                </div>
                <div class="col-12 col-md-4 mb-2">
                    <div v-if="capa.dadosGeraisCapa.TRANSBORDOSMARITIMOS[0] && (tipo == 'CMI' || tipo == 'CME')">
                        <p><strong>Transbordos Maritimos: </strong></p>
                        <p v-for="transbordosM in capa.dadosGeraisCapa.TRANSBORDOSMARITIMOS" :key="transbordosM.index">
                            <span >{{ transbordosM.PORTO - transbordosM.NAVIO }}</span>
                        </p>
                    </div>

                    <div v-if="capa.dadosGeraisCapa.CONTAINERS[0] && (tipo == 'CMI' || tipo == 'CME')">
                        <p><strong>Containers: </strong></p>
                        <div class="border m-1 p-1" v-for="containersM in capa.dadosGeraisCapa.CONTAINERS" :key="containersM.CONTAINER">
                            <p class="p-0 m-0" ><strong>Tipo:</strong> {{ containersM.TIPO || "----"}}</p>
                            <p class="p-0 m-0" ><strong>Num:</strong> {{containersM.CONTAINER || "----"}}</p>
                            <p class="p-0 m-0" ><strong>Vol:</strong> {{containersM.NET_WEIGHT || "----"}}</p>
                        </div>
                    </div>
                    <div v-if="capa.dadosGeraisCapa.TRANSBORDOSAEREOS[0] && (tipo == 'CAI' || tipo == 'CAE')">
                        <p><strong>Conexões: </strong></p>
                        <p v-for="transbordosA in capa.dadosGeraisCapa.TRANSBORDOSAEREOS" :key="transbordosA.index">
                            <span>{{ transbordosA.PORTO }}</span>
                        </p>
                    </div>

                    <div v-if="capa.dadosGeraisCapa.DOCUMENTOSANEXADOS[0]">
                        <p><strong>Documentos: </strong></p>
                        <p v-for="documento in capa.dadosGeraisCapa.DOCUMENTOSANEXADOS" :key="documento.index">
                            <a
                            href="#"
                            v-text="documento.ARQUIVO"
                            @click.prevent="openWindowWithPost(documento)" />
                        </p>
                    </div>
                </div>            
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Capa",
    props: ["capa"],
    data(){
        return {
            tipo: "",
        }
    },
    mounted(){
        this.checarTipo(this.capa.dadosGeraisCapa.PROCESSO);
    },
    methods:{
        checarTipo(processo){
            let tipo = processo.substring(0,3);
            this.tipo = tipo;
        },
        basename(path) {
            return path.split('/').reverse()[0];
        },
        openWindowWithPost(data) {
            var formDownload = document.createElement("form");
            formDownload.target = "_blank";
            formDownload.method = "POST";
            formDownload.action = this.$urlApi + "/api/download-file";
            formDownload.style.display = "none";
            for (var key in data) {
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = data[key];
                formDownload.appendChild(input);
            }
            console.log(formDownload);
            document.body.appendChild(formDownload);
            formDownload.submit();
            document.body.removeChild(formDownload);
        }
    }
}
</script>

<style scoped>
    p{
        font-size: 13px;
        padding: 0px;
        margin: 0px;
    }
    p span,.documento {
        font-size: 11px;
    }
    h3{
        margin-top: 0px;
        padding-top: 5px;
        font-size: 20px;
    }
    hr{
        margin: 5px;
    }
    
</style>